import { Edit05, Trash01 } from "@untitledui/icons";
import type React from "react";

// Custom DotsMove icon component
const DotsMove: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M15.5 6.79599C16.0523 6.79599 16.5 6.34827 16.5 5.79599C16.5 5.24371 16.0523 4.79599 15.5 4.79599C14.9477 4.79599 14.5 5.24371 14.5 5.79599C14.5 6.34827 14.9477 6.79599 15.5 6.79599Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 13.796C16.0523 13.796 16.5 13.3483 16.5 12.796C16.5 12.2437 16.0523 11.796 15.5 11.796C14.9477 11.796 14.5 12.2437 14.5 12.796C14.5 13.3483 14.9477 13.796 15.5 13.796Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 20.796C16.0523 20.796 16.5 20.3483 16.5 19.796C16.5 19.2437 16.0523 18.796 15.5 18.796C14.9477 18.796 14.5 19.2437 14.5 19.796C14.5 20.3483 14.9477 20.796 15.5 20.796Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 6.79599C9.05228 6.79599 9.5 6.34827 9.5 5.79599C9.5 5.24371 9.05228 4.79599 8.5 4.79599C7.94772 4.79599 7.5 5.24371 7.5 5.79599C7.5 6.34827 7.94772 6.79599 8.5 6.79599Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 13.796C9.05228 13.796 9.5 13.3483 9.5 12.796C9.5 12.2437 9.05228 11.796 8.5 11.796C7.94772 11.796 7.5 12.2437 7.5 12.796C7.5 13.3483 7.94772 13.796 8.5 13.796Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 20.796C9.05228 20.796 9.5 20.3483 9.5 19.796C9.5 19.2437 9.05228 18.796 8.5 18.796C7.94772 18.796 7.5 19.2437 7.5 19.796C7.5 20.3483 7.94772 20.796 8.5 20.796Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface WidgetHeaderProps {
  viewId?: string;
  viewName: string;
  editable?: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({ viewName, editable = false, onEdit, onDelete }) => {
  return (
    <div className="bg-gray-50 border-b border-gray-200 px-3 py-2 flex items-center justify-between transition-colors">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        {editable && (
          <div className="drag-handle cursor-move select-none">
            <DotsMove className="w-4 h-4 text-gray-400 flex-shrink-0" />
          </div>
        )}
        <span className="text-xs text-gray-700 font-medium truncate select-none">{viewName || "Untitled View"}</span>
      </div>
      {editable && (
        <div className="flex items-center gap-1 flex-shrink-0">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            className="p-1.5 hover:bg-gray-200 rounded transition-colors"
            aria-label="Edit report"
          >
            <Edit05 className="w-3.5 h-3.5 text-gray-500" />
          </button>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="p-1.5 hover:bg-red-100 rounded transition-colors"
            aria-label="Delete widget"
          >
            <Trash01 className="w-3.5 h-3.5 text-gray-500 hover:text-red-600" />
          </button>
        </div>
      )}
    </div>
  );
};
